import React, { useState, useEffect } from 'react'
import PatientService from '../../../../../../services/api/patient.service';
import HPTSelect from '../../../../../templates/components/HPTSelect';
import moment from 'moment';
import Utilities from '../../../../../../services/commonservice/utilities';
const SoapNotesForm = (props) => {
    const { submitHandler } = props
    const [patientList, setPatientList] = useState();
    const [inputData, setInputData] = useState({})

    useEffect(() => {
        //console.log("props?.initialData" + JSON.stringify(props?.initialData))
        if (props?.initialData) {
            setInputData(props.initialData);
        }
    }, [props?.initialData])
    const inputChange = (e) => {
        let newStateObject = { ...inputData };
        newStateObject[e.target.name] = e.target.value
        setInputData(newStateObject);
    }

    useEffect(() => {
        if (props.patientId) {
            PatientService.getPatientById(props?.patientId)
                .then((data) => {
                    // console.log(data)
                    setPatientList(data.data);
                }).catch((err) => {
                    console.log(err)
                });
        }
    }, [props?.patientId]);

    return (
        <>
            <div className="fields">
                <div className="field required sixteen wide column">
                    <label>Patient</label>
                    <HPTSelect
                        className="react-select-control"
                        classNamePrefix="react-select"
                        options={patientList}
                        name="patientId"
                        isDisabled
                        value={patientList}
                        onChange={e => {
                            inputChange({
                                target:
                                    { value: e.id, name: 'patientId' }
                            })
                        }}
                        getOptionLabel={option => option.firstName + ' ' + option.lastName + ' | ' + moment.utc(option.dob).format("M/D/YYYY") + ' | ' + (option?.mobile ? Utilities.toPhoneNumber(option.mobile) : option?.patientPhone ? Utilities.toPhoneNumber(option.patientPhone) : '----')}
                        getOptionValue={(option) => option.id}
                    />
                </div>
            </div>
            <div className="field sixteen wide column">
                <label>Subjective</label>
                <input type="text"
                    value={inputData.subjective}
                    onChange={e => {
                        e.preventDefault();
                        inputChange(e)
                    }}
                    name="subjective"
                    placeholder="Subjective" />
            </div>
            <div className="field sixteen wide column">
                <label>Objective</label>
                <textarea placeholder="Objective"
                    className="form-control"
                    value={inputData.objective}
                    onChange={e => {
                        e.preventDefault();
                        inputChange(e)
                    }}
                    name="objective"
                    rows={2}
                />
            </div>
            <div className="field sixteen wide column">
                <label>Assessment</label>
                <input type="text"
                    value={inputData.assessment}
                    onChange={e => {
                        e.preventDefault();
                        inputChange(e)
                    }}
                    name="assessment"
                    placeholder="Assessment" />
            </div>
            <div className="field sixteen wide column">
                <label>Plan</label>
                <textarea placeholder="Plan"
                    className="form-control"
                    value={inputData.plan}
                    onChange={e => {
                        e.preventDefault();
                        inputChange(e)
                    }}
                    name="plan"
                    rows={2}
                />
            </div>
            <div className="mt-3 d-flex justify-content-between modal-button-bar">
                <div className='col-auto'>
                    <button className="btn btn-primary" onClick={e => {
                        e.preventDefault();
                        submitHandler(inputData)
                    }}>{props.submitLabel || 'Add'}</button>
                </div>
                <div className="col-auto">
                    <button className="btn btn-secondary" onClick={e => { e.preventDefault(); if (props.onClose) { props.onClose() } }}>Close</button>
                </div>
            </div>
        </>
    )
}

export default SoapNotesForm